var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCinknestlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 32,
    viewBox: "0 0 301 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_340_267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.3612C0 6.98763 5.86141 0 16.4398 0C21.1126 0 24.9908 1.39614 27.368 3.02149L24.1078 11.315C21.9922 10.0994 20.3621 9.46733 18.0698 9.46733C13.7502 9.46733 11.3255 12.2631 11.3255 16.0486C11.3255 20.2857 13.7943 22.5848 18.114 22.5848C20.3621 22.5848 22.7427 21.9527 24.9874 20.7823L27.1914 29.3466C24.0637 31.104 20.1855 32.0069 16.3074 32.0069C6.47947 32 0 26.2765 0 16.3612Z",
    fill: "#9747FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6279 0.902969H41.9534V22.0881H54.4709V31.104H30.6279V0.902969Z",
    fill: "#9747FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1284 0.902969H69.4539V31.1005H58.1284V0.902969Z",
    fill: "#9747FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9062 0.902969H83.9107L93.2088 14.5136H93.2971V0.902969H103.302V31.1005H93.6503L83.999 17.5351H83.9107V31.1005H73.9062V0.902969Z",
    fill: "#9747FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.533 0.902969H118.858V13.6592L126.526 0.902969H138.161L129.389 15.7777L138.82 31.1005H126.744L118.855 18.5248V31.1005H107.529V0.902969H107.533Z",
    fill: "#9747FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.377 0.902969H151.381L160.68 14.5136H160.768V0.902969H170.772V31.1005H161.121L151.47 17.5351H151.381V31.1005H141.377V0.902969Z",
    fill: "#9747FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.003 0.902969H199.288V9.37703H186.332V11.7213H196.204V20.1954H186.332V22.6299H199.288V31.104H175.003V0.902969Z",
    fill: "#9747FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.151 27.6727L205.985 21.0011C208.454 22.8036 212.906 24.3803 215.592 24.3803C217.09 24.3803 217.708 23.9739 217.708 22.8939C217.708 21.6783 215.857 21.1365 213.432 20.4593C209.113 19.2438 203.03 17.483 203.03 10.3634C203.03 4.23355 208.097 -0.003479 216.383 -0.003479C221.406 -0.003479 226.035 1.57325 228.945 3.91751L226.299 10.544C223.566 8.78662 219.908 7.34534 217.355 7.34534C215.857 7.34534 214.886 7.70653 214.886 8.74148C214.886 9.87019 216.869 10.4537 219.338 11.1309C223.702 12.3464 229.607 14.1975 229.607 21.588C229.607 28.395 224.099 32 216.21 32C210.79 32 205.414 30.2427 202.151 27.6727Z",
    fill: "#9747FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.627 9.91534H231.594V0.902969H260.945V9.91881H251.956V31.104H240.63V9.91534H240.627Z",
    fill: "#9747FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 31.1005H270.895L281.473 18.247L290.826 23.9253L301 2.40677V31.1005Z",
    fill: "#9747FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.905 0.90992H299.01L288.431 13.7634L279.079 8.08509L268.905 29.6036V0.90992Z",
    fill: "#9747FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_340_267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 301,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinknestlogo);
export default __webpack_public_path__ + "static/media/cinknestlogo.d946236f32ddcfe52e43812b73ef6bc9.svg";
export { ForwardRef as ReactComponent };